import React from "react";

export default function ChipSelect({ options, selected, onChange, emptyLabel = "none available", testidPrefix }) {
  const toggle = (val) => {
    if (selected.includes(val)) onChange(selected.filter((v) => v !== val));
    else onChange([...selected, val]);
  };
  if (!options || options.length === 0) {
    return <span className="font-mono text-[11px] text-muted-foreground">{emptyLabel}</span>;
  }
  return (
    <div className="flex flex-wrap gap-1.5">
      {options.map((opt) => {
        const on = selected.includes(opt);
        return (
          <button
            key={opt}
            type="button"
            onClick={() => toggle(opt)}
            data-testid={testidPrefix ? `${testidPrefix}-${opt}` : undefined}
            className={`px-2 py-1 font-mono text-[11px] border transition-colors ${
              on
                ? "border-white bg-white text-black"
                : "border-border bg-black/50 text-muted-foreground hover:text-white hover:border-white/40"
            }`}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
}
